import { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet-async";
import { LanguageContext } from "../locales/LanguageContext";
import homeforTranslations from "../locales/homeforTranslations";

const Home = () => {
  const { lang } = useContext(LanguageContext);
  const t = homeforTranslations[lang];
  const [activeSlide, setActiveSlide] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {}, []);

  return (
    <div style={{ overflow: "hidden" }}>
      <Helmet>
        <title>AKAAL KIDS | Home</title>
      </Helmet>
      {/* Banner Image Slider */}
      {(() => {
        const slides = [
          {
            image: isMobile
              ? "../../assets/images/enroll-now-mb.png"
              : "../../assets/images/enroll-now.png",
            link: "/enroll",
          },
        ];

        return (
          <div
            style={{
              width: "100%",
              height: "600px",
              position: "relative",
              overflow: "hidden",
              marginBottom: 0,
              backgroundSize: "cover",
              backgroundPosition: "center",
              borderRadius: "0 0 0",
              boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
            }}
          >
            {/* Slider Container */}
            <div
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                overflow: "hidden",
              }}
            >
              {/* Image Slides */}
              {slides.map((slide, index) => (
                <a
                  key={index}
                  href={slide.link}
                  style={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    opacity: activeSlide === index ? 1 : 0,
                    transform:
                      activeSlide === index
                        ? "translateX(0)"
                        : index < activeSlide
                          ? "translateX(-100%)"
                          : "translateX(100%)",
                    transition: "all 0.5s ease-in-out",
                    backgroundImage: `url(${activeSlide === index ? slide.image : ""})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textDecoration: "none",
                    cursor: "pointer",
                  }}
                >
                  {/* Visually hidden text for accessibility */}
                  <span
                    style={{
                      position: "absolute",
                      left: "-9999px",
                      height: "1px",
                      width: "1px",
                      overflow: "hidden",
                    }}
                  >
                    {slide.alt || "Slide link"}
                  </span>
                </a>
              ))}
              {slides.length > 1 && (
                <div
                  style={{
                    position: "absolute",
                    bottom: 20,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: 12,
                    zIndex: 20,
                  }}
                >
                  {slides.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setActiveSlide(index)}
                      style={{
                        width: 12,
                        height: 12,
                        borderRadius: "50%",
                        border: "none",
                        background:
                          activeSlide === index
                            ? "#fff"
                            : "rgba(255,255,255,0.5)",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        boxShadow:
                          activeSlide === index
                            ? "0 0 8px rgba(255,255,255,0.8)"
                            : "none",
                      }}
                    />
                  ))}
                </div>
              )}

              {/* Left Arrow - Only show if more than 1 slide */}
              {slides.length > 1 && (
                <button
                  onClick={() =>
                    setActiveSlide((prev) =>
                      prev === 0 ? slides.length - 1 : prev - 1,
                    )
                  }
                  style={{
                    position: "absolute",
                    left: 20,
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    border: "2px solid white",
                    background: "rgba(255,255,255,0.2)",
                    color: "white",
                    fontSize: 24,
                    cursor: "pointer",
                    zIndex: 15,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.4)")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.2)")
                  }
                >
                  ❮
                </button>
              )}

              {/* Right Arrow - Only show if more than 1 slide */}
              {slides.length > 1 && (
                <button
                  onClick={() =>
                    setActiveSlide((prev) =>
                      prev === slides.length - 1 ? 0 : prev + 1,
                    )
                  }
                  style={{
                    position: "absolute",
                    right: 20,
                    top: "50%",
                    transform: "translateY(-50%)",
                    width: 50,
                    height: 50,
                    borderRadius: "50%",
                    border: "2px solid white",
                    background: "rgba(255,255,255,0.2)",
                    color: "white",
                    fontSize: 24,
                    cursor: "pointer",
                    zIndex: 15,
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.4)")
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.background = "rgba(255,255,255,0.2)")
                  }
                >
                  ❯
                </button>
              )}

              <style>{`
                @keyframes slideInContent {
                  0% {
                    opacity: 0;
                    transform: scale(0.95);
                  }
                  100% {
                    opacity: 1;
                    transform: scale(1);
                  }
                }

                @keyframes slideInFromLeft {
                  0% {
                    opacity: 0;
                    transform: translateX(-100%);
                  }
                  100% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                }

                @keyframes slideInFromRight {
                  0% {
                    opacity: 0;
                    transform: translateX(100%);
                  }
                  100% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                }

                @keyframes slideOutToLeft {
                  0% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                  100% {
                    opacity: 0;
                    transform: translateX(-100%);
                  }
                }

                @keyframes slideOutToRight {
                  0% {
                    opacity: 1;
                    transform: translateX(0);
                  }
                  100% {
                    opacity: 0;
                    transform: translateX(100%);
                  }
                }
              `}</style>
            </div>
          </div>
        );
      })()}
      {/* Welcome Banner */}

      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 8,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          Welcome to{" "}
          <span
            style={{
              color: "#fff",
              background: "rgba(0,0,0,0.10)",
              borderRadius: 8,
              padding: "0 10px",
            }}
          >
            AKAAL KIDS
          </span>
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="star">
            🌟
          </span>{" "}
          Founded under Shan-E-Khalsa (Since 2006) Inspired by Fatehgarh Sahib
        </div>
      </div>

      {/* PHOTO OVERLAY TEXT starts */}
      <section
        style={{
          position: "relative",
          minHeight: "500px",
          display: "flex",
          alignItems: "center",
          padding: "70px 0",
          justifyContent: "center",
          overflow: "hidden",
          marginBottom: 40,
        }}
      >
        {/* Background Overlay Image */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 1,
          }}
        />

        {/* Dark Overlay */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",

            zIndex: 2,
          }}
        />

        {/* Content Container */}
        <div
          className="container"
          style={{
            position: "relative",
            zIndex: 3,
          }}
        >
          <div className="row align-items-center">
            {/* Left Section - Content */}
            <div className="col-lg-6 col-md-12 mb-4 mb-lg-0">
              <div
                style={{
                  color: "#fff",
                  animation: "fadeInUp 1s ease-out",
                }}
              >
                <span
                  style={{
                    display: "inline-block",
                    color: "#f6b93b",
                    fontWeight: 700,
                    fontSize: "18px",
                    marginBottom: 12,
                    letterSpacing: 2,
                    textTransform: "uppercase",
                  }}
                >
                  {t.aboutShortHeading}
                </span>

                <p
                  style={{
                    fontSize: "1rem",
                    opacity: 0.85,
                    color: "#000",
                    marginLeft: 0,
                    marginBottom: 24,
                    lineHeight: 1.7,
                  }}
                >
                  {t.aboutShortText}
                </p>
                <a
                  href="/about"
                  className="btn btn-lg fw-bold"
                  style={{
                    background:
                      "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
                    color: "#fff",
                    fontSize: 18,
                    borderRadius: 32,
                    padding: "12px 36px",
                    boxShadow: "0 4px 16px #f6815e55",
                    border: "none",
                    letterSpacing: 1,
                    transition: "all 0.3s ease",
                    textDecoration: "none",
                    display: "inline-block",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 6px 20px #f6815e77";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 16px #f6815e55";
                  }}
                >
                  {t.aboutShortBtn}
                </a>
              </div>
            </div>

            {/* Right Section - Image */}
            <div className="col-lg-6 col-md-12">
              <div
                style={{
                  position: "relative",
                  display: "flex",
                  justifyContent: "center",
                  animation: "fadeInRight 1s ease-out",
                }}
              >
                {/* Image with shadow and border */}
                <img
                  src="../../assets/images/bak-image.jpg"
                  alt="Gurmat Education"
                  style={{
                    width: "100%",
                    maxWidth: "500px",
                    height: "auto",
                    borderRadius: "16px",
                    boxShadow: "0 12px 32px rgba(0,0,0,0.4)",
                    border: "4px solid #f6b93b",
                    objectFit: "cover",
                    transition: "transform 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.05) rotate(2deg)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1) rotate(0deg)";
                  }}
                />

                {/* Decorative Circle */}
                <div
                  style={{
                    position: "absolute",
                    top: -30,
                    right: -30,
                    width: 120,
                    height: 120,
                    borderRadius: "50%",
                    border: "3px solid #f6815e33",
                    zIndex: 0,
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: -20,
                    left: -40,
                    width: 140,
                    height: 140,
                    borderRadius: "50%",
                    border: "3px solid #f6b93b33",
                    zIndex: 0,
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <style>{`
          @keyframes fadeInUp {
            0% {
              opacity: 0;
              transform: translateY(40px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }

          @keyframes fadeInRight {
            0% {
              opacity: 0;
              transform: translateX(40px);
            }
            100% {
              opacity: 1;
              transform: translateX(0);
            }
          }
        `}</style>
      </section>
      {/* PHOTO OVERLAY TEXT finish */}

      {/* video sections starts */}
      <section
        style={{
          float: "left",
          width: "100%",
          padding: " 0 0 50px 0",
        }}
      >
        <div className="container">
          {/* <video style={{
  float: 'left',
  width: '100%',
}} height="500" controls> 
      <source src="https://akaalkids.com/assets/video/Overview.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video> */}

          <iframe
            style={{
              float: "left",
              width: "100%",
            }}
            height="500"
            src="https://www.youtube.com/embed/zMkhQabhjJ0?si=VK2FZlMjrGfEEdIM"
            title="Akaal Kids Overview"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </section>
      {/* video sections finish */}

      <section className="why-akaal-section py-4 bg-white">
        <div className="container mb-4">
          <div
            style={{
              background: "linear-gradient(120deg, #fffbe6 0%, #f6b93b33 100%)",
              borderRadius: 22,
              boxShadow: "0 4px 32px #f6b93b44",
              padding: "38px 32px 30px 32px",
              marginBottom: 24,
              position: "relative",
              overflow: "hidden",
              animation: "fadeInUp 1s",
            }}
          >
            <div className="row align-items-center">
              {/* Left Section */}
              <div className="col-md-6">
                <div
                  style={{
                    position: "absolute",
                    top: -30,
                    right: -30,
                    opacity: 0.13,
                    fontSize: 140,
                  }}
                >
                  <span role="img" aria-label="light-bulb">
                    💡
                  </span>
                </div>
                <h2
                  style={{
                    color: "#f6815e",
                    fontWeight: 900,
                    fontSize: "2.3rem",
                    marginBottom: 18,
                    letterSpacing: 1,
                    textShadow: "0 2px 12px #f6b93b55",
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <span role="img" aria-label="why" style={{ fontSize: 38 }}>
                    🔸
                  </span>
                  {t.whyHeading}
                  <span
                    role="img"
                    aria-label="sparkle"
                    style={{ fontSize: 32, marginLeft: 8 }}
                  >
                    ✨
                  </span>
                </h2>
                <ul
                  style={{
                    fontSize: "1.18em",
                    color: "#444",
                    marginBottom: 18,
                    paddingLeft: 22,
                    fontWeight: 500,
                    lineHeight: 1.7,
                  }}
                >
                  {t.whyPoints.map((point, idx) => (
                    <li
                      key={idx}
                      style={{
                        marginBottom: 10,
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 10,
                      }}
                    >
                      <span style={{ color: "#f6b93b", fontSize: 22 }}>•</span>
                      <div>{point}</div>
                    </li>
                  ))}
                </ul>
                <div
                  style={{
                    fontSize: "1.18em",
                    color: "#b26a00",
                    fontWeight: 700,
                    marginBottom: 8,
                    letterSpacing: 0.5,
                  }}
                >
                  Our goal is simple:
                </div>
                <div
                  style={{
                    fontSize: "1.18em",
                    color: "#444",
                    marginBottom: 0,
                    fontWeight: 500,
                  }}
                >
                  To prepare learners globally by the age of 15 to confidently
                  read, understand, and live Gurbani.
                </div>
              </div>
              {/* Right Side Image */}
              <div
                className="col-md-6"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: 20,
                }}
              >
                <div
                  style={{
                    position: "relative",
                    display: "flex",
                    justifyContent: "center",
                    animation: "fadeInRight 1s ease-out",
                  }}
                >
                  <img
                    src="../../assets/images/gurmat-readng.png"
                    alt="Why Akaal Kids"
                    style={{
                      width: "100%",
                      maxWidth: "450px",
                      height: "auto",
                      borderRadius: "16px",
                      boxShadow: "0 12px 32px rgba(0,0,0,0.15)",
                      border: "4px solid #f6b93b",
                      objectFit: "cover",
                      transition: "transform 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.transform = "scale(1.05) rotate(1deg)";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.transform = "scale(1) rotate(0deg)";
                    }}
                  />

                  {/* Decorative Circles */}
                  <div
                    style={{
                      position: "absolute",
                      top: -25,
                      right: -25,
                      width: 100,
                      height: 100,
                      borderRadius: "50%",
                      border: "3px solid #f6815e33",
                      zIndex: 0,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      bottom: -15,
                      left: -35,
                      width: 120,
                      height: 120,
                      borderRadius: "50%",
                      border: "3px solid #f6b93b33",
                      zIndex: 0,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Four Card Section Start */}
      <section style={{ background: "#fffbe6", padding: "60px 0" }}>
        <div className="container">
          <h2
            style={{
              textAlign: "center",
              fontWeight: 900,
              fontSize: "2.5rem",
              color: "#f6815e",
              marginBottom: 0,
              letterSpacing: 1,
            }}
          >
            OUR LEARNING MODEL
          </h2>
          <div
            style={{
              textAlign: "center",
              fontSize: "1.25rem",
              color: "#b26a00",
              marginBottom: 40,
              fontWeight: 500,
            }}
          >
            How Children Learn at Akaal Kids
          </div>
          {/* Dynamic two-card-per-row grid */}
          <div className="row justify-content-center">
            {t.learningCards.map((card, idx) => (
              <div key={idx} className="col-md-6 col-lg-3 mb-4">
                <div
                  style={{
                    background: card.bg,
                    borderRadius: 18,
                    boxShadow: "0 6px 24px rgba(0,0,0,0.08)",
                    padding: "32px 20px",
                    textAlign: "center",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div style={{ fontSize: 44, marginBottom: 16 }}>
                    {card.icon}
                  </div>
                  <h4
                    style={{
                      fontWeight: 800,
                      fontSize: "1.3rem",
                      color: card.color,
                      marginBottom: 0,
                      paddingBottom: 0,
                    }}
                  >
                    {card.title}
                  </h4>
                  <p
                    style={{
                      color: "#444",
                      fontSize: "1.05rem",
                      fontWeight: 500,
                    }}
                  >
                    {card.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Four Card Section End */}

      {/* four card section finish */}

      {/* add premium batches section starts */}
      <section
        style={{ padding: "80px 0", marginBottom: 50, background: "#f8f9fa" }}
      >
        <div className="container">
          <div className="text-center mb-5">
            <h2
              style={{
                color: "#f6815e",
                fontWeight: 900,
                fontSize: "2.5rem",
                marginBottom: 16,
              }}
            >
              {t.coursesHeading}
            </h2>
            <p
              style={{
                fontSize: "1.25rem",
                color: "#555",
                fontWeight: 500,
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              {t.coursesText}
            </p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div
                className="card border-0 shadow-lg"
                style={{ borderRadius: 20, overflow: "hidden" }}
              >
                <div className="card-body p-5" style={{ background: "#fff" }}>
                  <div className="row">
                    <div className="col-md-6 mb-4 mb-md-0">
                      <h4
                        style={{
                          color: "#b26a00",
                          fontWeight: 700,
                          marginBottom: 24,
                          fontSize: "1.5rem",
                        }}
                      >
                        <span role="img" aria-label="levels">
                          📚
                        </span>{" "}
                        Available Levels:
                      </h4>
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {t.levels.map((level, idx) => (
                          <li
                            key={idx}
                            style={{
                              marginBottom: 12,
                              fontSize: "1.1rem",
                              color: "#444",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                color: "#f6b93b",
                                fontSize: "1.2rem",
                                marginRight: 12,
                                fontWeight: "bold",
                              }}
                            >
                              ✓
                            </span>
                            {level}
                          </li>
                        ))}
                      </ul>
                    </div>
                    <div className="col-md-6">
                      <h4
                        style={{
                          color: "#b26a00",
                          fontWeight: 700,
                          marginBottom: 24,
                          fontSize: "1.5rem",
                        }}
                      >
                        <span role="img" aria-label="format">
                          ⏰
                        </span>{" "}
                        Class Format:
                      </h4>
                      <ul style={{ listStyle: "none", padding: 0 }}>
                        {t.classFormat.map((item, idx) => (
                          <li
                            key={idx}
                            style={{
                              marginBottom: 12,
                              fontSize: "1.1rem",
                              color: "#444",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <span
                              style={{
                                color: "#f6815e",
                                fontSize: "1.5rem",
                                marginRight: 12,
                                lineHeight: 0,
                              }}
                            >
                              •
                            </span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>

                  <div className="text-center mt-5">
                    <a
                      href="/batches"
                      className="btn btn-lg"
                      style={{
                        background:
                          "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
                        color: "#fff",
                        borderRadius: 32,
                        padding: "14px 40px",
                        fontSize: "1.2rem",
                        fontWeight: 700,
                        border: "none",
                        boxShadow: "0 4px 16px #f6815e44",
                        transition: "transform 0.2s",
                        textDecoration: "none",
                        display: "inline-block",
                      }}
                      onMouseEnter={(e) =>
                        (e.target.style.transform = "scale(1.05)")
                      }
                      onMouseLeave={(e) =>
                        (e.target.style.transform = "scale(1)")
                      }
                    >
                      {t.batchesBtn}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* add premium batches section finish */}

      {/* enroll now limited section starts  */}
      <section style={{ padding: "60px 0", background: "#fff" }}>
        <div className="container text-center">
          <h2
            style={{
              color: "#f6815e",
              fontWeight: 900,
              fontSize: "2.5rem",
              marginBottom: 24,
            }}
          >
            {t.admissionHeading}
          </h2>
          <p
            style={{
              fontSize: "1.25rem",
              color: "#555",
              fontWeight: 500,
              maxWidth: "700px",
              margin: "0 auto 40px auto",
            }}
          >
            {t.admissionText}
          </p>
          <div className="d-flex justify-content-center gap-3 flex-wrap">
            <a
              href="/enroll"
              className="btn btn-lg"
              style={{
                background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
                color: "#fff",
                borderRadius: 32,
                padding: "12px 36px",
                fontSize: "1.2rem",
                fontWeight: 700,
                border: "none",
                boxShadow: "0 4px 16px #f6815e44",
                textDecoration: "none",
              }}
            >
              {t.admissionBtn}
            </a>
            <a
              href="https://wa.me/"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-lg"
              style={{
                background: "#25D366",
                color: "#fff",
                borderRadius: 32,
                padding: "12px 36px",
                fontSize: "1.2rem",
                marginLeft: 15,
                fontWeight: 700,
                border: "none",
                boxShadow: "0 4px 16px #25D36644",
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span role="img" aria-label="whatsapp">
                💬
              </span>{" "}
              {t.whatsappBtn}
            </a>
          </div>
        </div>
      </section>
      {/* enroll now limited section finish */}
    </div>
  );
};

export default Home;
